import { useState } from "react";
import { useConfig } from "../../config/ConfigContext";
import formatPrice from "../../utils/formatPrice";
import CardMediaCarousel from "./CardMediaCarousel";
import QuantitySelector from "./QuantitySelector";
import ToyDetail from "./ToyDetail";

const HI_BADGES = new Set([
  "popular",
  "top pick",
  "exclusive",
  "premium",
  "best-seller",
  "bestseller",
]);

export default function ToyCard({ toy }) {
  const config = useConfig();
  const fields = toy.fields;
  const [isOpen, setIsOpen] = useState(false);

  const tagsRaw = fields["Tags"];
  const tagsStr =
    typeof tagsRaw === "string" ? tagsRaw.trim() : String(tagsRaw || "").trim();
  const badgeRaw =
    fields["Badge"] ||
    fields["badge"] ||
    fields["Étiquette"] ||
    toy.displayBadge ||
    tagsStr;
  const badge =
    typeof badgeRaw === "string" ? badgeRaw.trim() : String(badgeRaw || "");
  const badgeNorm = badge
    ? badge.toLowerCase().replace(/\s+/g, "-").replace(/-+/g, "-")
    : "";
  const badgeHi = badge && (HI_BADGES.has(badgeNorm) || HI_BADGES.has(badgeNorm.replace(/-/g, "")));

  const note =
    fields["Mention spéciale"] ||
    fields["Note"] ||
    fields["Notes"] ||
    fields["Note livraison"] ||
    fields["Client note"];

  const openDetail = () => {
    setIsOpen(true);
  };

  return (
    <>
      <article className="card">
        <div className="card-media-slot">
          {badge ? (
            <div className={`c-badge${badgeHi ? " hi" : ""}`}>{badge}</div>
          ) : null}
          {fields["Photos"]?.length ? (
            <CardMediaCarousel
              photos={fields["Photos"]}
              alt={fields["Name"] || ""}
              onOpen={openDetail}
            />
          ) : (
            <div
              className="c-wrap card-carousel-root"
              onClick={openDetail}
              role="presentation"
            >
              <div className="emoji-fb">🧸</div>
            </div>
          )}
          {note ? (
            <div className="c-note">
              <span className="c-note-icon">⚠️</span>
              {note}
            </div>
          ) : null}
        </div>
        <div className="card-body">
          <div className="card-top">
            <h3 className="card-name">{fields["Name"]}</h3>
            <div className="card-price">
              €{formatPrice(fields[config.itemPriceFieldTTC])}
              <span className="card-unit">/ day</span>
            </div>
          </div>
          <div className="card-foot">
            <QuantitySelector toy={toy} mode="card" />
          </div>
        </div>
      </article>
      <ToyDetail
        toy={toy}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        showAddToCart={true}
      />
    </>
  );
}
